import {GraphRange} from '@shareland/shareland-common';
import {FunctionComponent, PropsWithChildren, createContext, useContext, useState} from 'react';
import {useTranslation} from 'react-i18next';

type GraphRangeContextValue = {
  graphRange: GraphRange;
  setDateType: (graphRange: GraphRange) => void;
};
export const GraphRangeContext = createContext<GraphRangeContextValue>({} as GraphRangeContextValue);

export const GraphRangeProvider: FunctionComponent<PropsWithChildren<{defaultDateType?: GraphRange}>> = ({
  children,
  defaultDateType = 'day',
}) => {
  const [graphRange, setDateType] = useState(defaultDateType);
  return <GraphRangeContext.Provider value={{graphRange, setDateType}}>{children}</GraphRangeContext.Provider>;
};

export const GraphRangeSelector: FunctionComponent<{className?: string}> = ({className = ''}) => {
  return (
    <div className={`flex w-full justify-center gap-4 ${className}`}>
      <Button graphRange={'hour'} />
      <Button graphRange={'day'} />
      <Button graphRange={'week'} />
      <Button graphRange={'month'} />
      <Button graphRange={'year'} />
      <Button graphRange={'all'} />
    </div>
  );
};

const Button: FunctionComponent<{
  graphRange: GraphRange;
}> = ({graphRange}) => {
  const {t} = useTranslation('translation', {
    keyPrefix: 'components.graphRangeSelector',
  });

  const {graphRange: selectedDateType, setDateType} = useContext(GraphRangeContext);

  const isSelected = graphRange === selectedDateType;

  const unselectedButtonStyle = 'bg-gray-800 border-gray-800 text-white';
  const selectedButtonStyle = 'bg-deepblue border-deepblue text-white';
  const className = `w-12 px2 py-1 rounded-lg text-sm font-semibold border  hover:opacity-70 ${
    isSelected ? selectedButtonStyle : unselectedButtonStyle
  }`;

  const onClick = () => {
    setDateType(graphRange);
  };
  return (
    <button className={className} onClick={onClick}>
      {t(graphRange)}
    </button>
  );
};

export default GraphRangeSelector;
